import { createAction, props } from "@ngrx/store";
import { QuestionAnswerResult } from "src/app/_models/QuestionResults";
import { SkillsCheckQandAActionTypes } from "src/app/constants/StoreConstants";

export const SetState = createAction(
	SkillsCheckQandAActionTypes.SetState,
  props<{state: QuestionAnswerResult, courseId: number}>()
);

export const SetStateSuccess = createAction(
	SkillsCheckQandAActionTypes.SetStateSuccess
);